// extracted by mini-css-extract-plugin
export var container = "index-module--container--+Z5cy";
export var content = "index-module--content--NTZSY";